import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, TextField } from "@mui/material";
import TextInputBox from "../../components/TextInputBox";
import ButtonBox from "../../components/ButtonBox";
import DialogBox from "../../components/DialogBox";
import { addLocalStorage, removeLocalStorage, useError } from "../../utils/functions";
import MemberApi from "../../api/MemberApi";
import LoginApi from "../../api/LoginApi";
import { USER_EMAIL, USER_ID, USER_NAME } from "../../constants";

interface UserInfo {
  userId: string;
  organization: string;
  email: string;
  name: string;
}

const Profile: React.FC = () => {
  const { setError } = useError();
  const [openDialog, setOpenDialog] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo>({
    userId: "",
    organization: "",
    email: "",
    name: "",
  });

  const getUserInfo = async () => {
    const meResponse = await LoginApi.getMe();

    if (meResponse.code) {
      setError(meResponse.message);
    }
    const orgResponse = await LoginApi.getOrg();
    if (orgResponse.code) {
      setError(meResponse.message);
    }
    setUserInfo({
      userId: meResponse.id,
      organization: orgResponse.name,
      name: meResponse.name,
      email: meResponse.email,
    });
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const handleEditClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmEdit = async () => {
    const memberResponse = await MemberApi.updateMember(
      userInfo.userId,
      userInfo.name,
      userInfo.email,
      ""
    );
    if (memberResponse.code) {
      setError(memberResponse.message);
    }

    const meResponse = await LoginApi.getMe();
    removeLocalStorage(USER_ID);
    removeLocalStorage(USER_NAME);
    removeLocalStorage(USER_EMAIL);
    const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(500); // 延遲 500 毫秒
    addLocalStorage(USER_ID, meResponse.id);
    addLocalStorage(USER_NAME, meResponse.name);
    addLocalStorage(USER_EMAIL, meResponse.email);
    setOpenDialog(false);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 4 }}>
      <Typography variant="h4">Account</Typography>
      <Paper elevation={2} sx={{ p: 4, mt: 2 }}>
        <Typography variant="h6">Profile</Typography>
        <TextInputBox
          label="Organization"
          value={userInfo.organization}
          disabled={true}
          className="w400"
        />
        <TextInputBox
          label="Email"
          value={userInfo.email}
          disabled={true}
          className="w400"
        />
        <Typography variant="h6" align="left" gutterBottom>
          Name
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <TextField
            value={userInfo.name}
            variant="outlined"
            className="w400"
            size="small"
            disabled
          />
          <ButtonBox text="EDIT" onClick={handleEditClick} />
        </Box>
      </Paper>

      <DialogBox
        open={openDialog}
        title="Edit Name"
        dialogContent={
          <TextInputBox
            label="Name"
            value={userInfo.name}
            onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
          />
        }
        onCancel={handleCloseDialog}
        onConfirm={handleConfirmEdit}
        confirmLabel="Save"
      />
    </Box>
  );
};

export default Profile;
